import { useContext } from "react";
import { OspApiClientContext } from "@features";

export const useOspApiClientProvider = () => {
  const context = useContext(OspApiClientContext);

  if (!context) {
    throw new Error(
      "useOspApiClientProvider must be used within a OspApiClientContext",
    );
  }

  return context;
};
